import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { AppLabel } from "../../component/AppLabel";
import { AppInput } from "../../component/AppInput";

import {
  AppCheckBox,
  AppInputGroup,
  AppSelect,
  AppTextArea,
  SelectOption,
} from "@dcam/dcam_flhealth_component_library";
import { AppButton } from "../../component/AppButton";
import ApiClient from "../../client/ApiClient";
import useGetData from "../../hooks/useGetData";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import usePost from "../../hooks/usePost";
import { ApiResponse } from "../Dashboard/ApiResponse";
import {
  CreateUserFormValidationSchema,
  RoleData,
  UserDataFormRequest,
} from "./CreateUser.types";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import Loader from "../../component/Loader/Loader";
import { AppCard } from "../../component/AppCard";
import { faDownload } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppDataTable } from "../../component/AppDataTable/AppDataTable";
import { useDownloadFile } from "../../hooks/useDownloadFile";
import { UserDetails } from "../Dashboard/Dashboard.types";

const mapToSelectOptions = (data: RoleData[]): SelectOption[] => {
  return data?.map((item) => ({
    value: item.id,
    label: item.value,
  }));
};

interface UserProps {
  email?: any;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleSave?: () => void;
}


export const EditUser: React.FC<UserProps> = ({
  email,
  onClick,
  handleSave
}) => {
  const isAuthenticated = useIsAuthenticated();

  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const loggedInUser = accounts[0] && accounts[0].username;

  const methods = useForm({
    resolver: yupResolver(CreateUserFormValidationSchema),
    defaultValues: {
      userIsActive: true,
      createdBy: loggedInUser,
    },
  });

  const [fieldsEnabled, setFieldsEnabled] = useState(true);
  const [emailError, setEmailError] = useState("");
  const [roleId, setRole] = useState(0);
  const [emailErrorColor, setEmailErrorColor] = useState("");
  const [userId, setuserId] = useState(0);
  const [userFiles, setUserFiles] = useState<any[]>([]);
  const token = sessionStorage.getItem("accessToken");
  const { downloadFile } = useDownloadFile();

  const [routinizedHospitalEnabled, setRoutinizedHospitalEnabled] =
    useState(false);
  const [routinizedFacilityEnabled, setRoutinizedFacilityEnabled] =
    useState(false);

  const { getDataById: getUserId } = useGetData<any, string>(
    "UserSecurity/GetUserSecurityByEmail/" + account.username,
    "GET"
  );

  const { getDataById: getUserByEmail } = useGetData(
    `UserSecurity/GetUserSecurityByEmail`,
    "GET"
  );

  const [allRolesData, setAllRolesData] = useState<SelectOption[]>([]);
  const { getDataById: getRoles } = useGetData<RoleData[], string>(
    "Client/Roles",
    "GET"
  );

  const { getDataById: getFilesByUserId } = useGetData<any[], number>(
    `FileUpload/GetByUserId`,
    "GET"
  );

  const [filteredRoutinizedFacilities, setFilteredRoutinizedFacilities] =
    useState<any[]>([]);


  const [userDetails, setUserDetails] = useState<UserDetails>();

  const hasFetched = useRef(false); // Declare outside useEffect

  useEffect(() => {
    debugger;
    const fetchUserData = async () => {
      try {
        const userData = await getUserId("");
        if (userData?.user && userData?.user?.isActive) {
          setUserDetails({ ...userData.user }); // Update state
        } else {
          navigate('/unauthorized');
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    if (isAuthenticated && !hasFetched.current) {
      hasFetched.current = true; // Mark as fetched
      fetchUserData();
    }
  }, [isAuthenticated, getUserId]); // Dependency array


  useEffect(() => {
    let isMounted = true;

    const fetchCurrentUser = async () => { //Logged in User Data
      try {
        const data = await getUserId("");
        if (data) {

          setRole(data?.user?.roleId)
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };

    fetchCurrentUser();

    const fetchRoles = async () => {
      try {
        const data = await getRoles("");
        if (data && isMounted) {
          const mappedRoles = mapToSelectOptions(data);
          setAllRolesData([
            { value: "0", label: "----- Select Role -----" },
            ...mappedRoles,
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };



    fetchRoles();

    const fetchUser = async () => {
      try {
        let data = await getUserByEmail(email) as any;
        if (data) {
          methods.setValue("userFirstName", data?.user?.firstName);
          methods.setValue("userLastName", data?.user?.lastName);
          methods.setValue("userAddress", data?.user?.streetAddress);
          methods.setValue("userCity", data?.user?.city);
          methods.setValue("userZipcode", data?.user?.zipCode);

          methods.setValue("userPhone", data?.user?.workPhone);
          methods.setValue("userNotes", data?.user?.notes);
          methods.setValue("routinizedHospital", data?.user?.routinizedHospitalId ? data?.user?.routinizedHospitalId : 0);

          methods.setValue("userRole", data?.user?.roleId);
          methods.setValue("userIsActive", data?.user?.isActive);
          methods.setValue("userEmail", data?.user?.email);
          methods.setValue("routinizedFacility", data?.user?.routinizedFacilityId ? data?.user?.routinizedFacilityId : 0);
          methods.setValue(
  "createdBy",
  data?.user?.createdBy ? data.user.createdBy : "N/A"
);
methods.setValue(
  "dateCreated",
  data?.user?.dateCreated
    ? new Date(data.user.dateCreated).toLocaleString()
    : "N/A"
);
          methods.setValue(
  "updatedBy",
  data?.user?.updatedBy ? data.user.updatedBy : "N/A"
);
methods.setValue(
  "dateUpdated",
  data?.user?.dateUpdated
    ? new Date(data.user.dateUpdated).toLocaleString()
    : "N/A"
);

          setuserId(data?.user?.userId);
          if (data?.user?.roleId == "0" || data?.user?.roleId == "1") {
            setRoutinizedHospitalEnabled(true);
            setRoutinizedFacilityEnabled(false);
            // setFilteredRoutinizedFacilities([]);
          } else {
            setRoutinizedHospitalEnabled(true);
          }
          const facilityData = await getRoutinizedFacilities(
            `${data?.user?.routinizedHospitalId}`
          );

          if (facilityData) {
            const mappedFacilities = mapToSelectOptions(facilityData);
            setFilteredRoutinizedFacilities([
              { value: "0", label: "----- Select Routinized Facilities -----" },
              ...mappedFacilities,
            ]);
            setRoutinizedFacilityEnabled(true);

          }

        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };



    fetchUser();
    const fetchRoutinizedHospitals = async () => {
      try {
        var data: RoleData[] = await getRoutinizedHospitals("");
        if (data && isMounted) {
          if (userDetails?.roleName == 'Provider' || userDetails?.roleName == 'Staff' || userDetails?.roleName == 'HIV Provider' || userDetails?.roleName == 'STD Provider') {
            data = data.filter(
              (hospital) => hospital.value == userDetails.routinizedHospitalName
            )
          }
          const mappedRoles = mapToSelectOptions(data);
          setallRoutinizedHospitalsData([
            { value: "0", label: "----- Select Routinized Hospitals -----" },
            ...mappedRoles,
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };



    fetchRoutinizedHospitals()
    fetchUser();


    return () => {
      isMounted = false;
    };
  }, [userDetails]);

  const [allRoutinizedHospitalsData, setallRoutinizedHospitalsData] = useState<
    SelectOption[]
  >([]);
  const { getDataById: getRoutinizedHospitals } = useGetData<
    RoleData[],
    string
  >("Client/RoutinizedHospitals", "GET");

  const navigate = useNavigate();



  const { postByObject: postUser } = usePost<ApiResponse, UserDataFormRequest>(
    "UserSecurity/Update",
    "POST"
  );

  const [isLoader, setisLoader] = useState<boolean>(false);

  const handleCreateUserSubmit = async () => {
    const userFormData = methods.getValues();
    userFormData.createdBy = methods.getValues("createdBy");
    userFormData.updatedBy = loggedInUser;

    const userConfirmed = window.confirm(
      "Please confirm if you would like to save?"
    );
    if (!userConfirmed) {
      return;
    }

    try {
      setisLoader(true);
      var data = userFormData as any;
      data.userId = userId;
      data.createdBy = methods.getValues("createdBy");
      data.updatedBy = loggedInUser;
      data.userCity = data.userCity ? data.userCity : "";
      data.userNotes = data.userNotes ? data.userNotes : "";
      data.userPhone = data.userPhone ? data.userPhone : "";
      data.userAddress = data.userAddress ? data.userAddress : "";
      data.userZipcode = data.userZipcode ? data.userZipcode : "";
      const saveResponse = await postUser(userFormData);
      console.log(saveResponse);

      toast.success("Data saved successfully!", {
        position: "top-right",
        autoClose: 2000,
      });

      setTimeout(() => {
        if (handleSave)
          handleSave();
        setisLoader(false);
      }, 2000);
    } catch (error) {
      setisLoader(false);
      toast.error("Failed to save user!", {
        position: "top-right",
        autoClose: 2000,
      });
      console.error(error);
    }

  };

  const handleEmailChange = () => {
    methods.reset({
      userEmail: methods.getValues("userEmail"),
      userAddress: "",
      userCity: "",
      userFirstName: "",
      userLastName: "",
      userPhone: "",
      userRole: "0",
      userZipcode: "",
      userNotes: "",
      routinizedFacility: "",
      routinizedHospital: "0",
    });
    setEmailError("");
    setFieldsEnabled(false);
    setRoutinizedFacilityEnabled(false);
    setRoutinizedHospitalEnabled(false);
  };

  const handleClearButton = () => {
    methods.reset({
      userEmail: "",
      userAddress: "",
      userCity: "",
      userFirstName: "",
      userLastName: "",
      userPhone: "",
      userRole: "0",
      userZipcode: "",
      userNotes: "",
      routinizedFacility: "",
      routinizedHospital: "0",
    });
    setEmailError("");
    setFieldsEnabled(false);
    setRoutinizedFacilityEnabled(false);
    setRoutinizedHospitalEnabled(false);
  };

  const [isUserFormEnable, setUserFormEnable] = useState(true);


  const { getDataById: getRoutinizedFacilities } = useGetData<
    RoleData[],
    string
  >("Client/RoutinizedFacilities", "GET");

  const handleRoutinizedHospitalChange = async () => {
    const selectedHospital = methods.getValues("routinizedHospital");

    if (selectedHospital == "0") {
      setFilteredRoutinizedFacilities([]);
      setRoutinizedFacilityEnabled(false);
    } else {
      try {
        const facilityData = await getRoutinizedFacilities(
          `${selectedHospital}`
        );

        if (facilityData) {
          const mappedFacilities = mapToSelectOptions(facilityData);
          setFilteredRoutinizedFacilities([
            { value: "0", label: "----- Select Routinized Facilities -----" },
            ...mappedFacilities,
          ]);
        }

        setRoutinizedFacilityEnabled(true);
      } catch (error) {
        setFilteredRoutinizedFacilities([]);
        setRoutinizedFacilityEnabled(false);
      }
    }
  };

  const handleRoleChange = () => {
    const role = methods.getValues("userRole");

    if (role == "0" || role == "1") {
      setRoutinizedHospitalEnabled(false);
      setRoutinizedFacilityEnabled(false);
      setFilteredRoutinizedFacilities([]);
    } else {
      setRoutinizedHospitalEnabled(true);
    }
  };

  const handleBackButton = (event: any) => {
    event.preventDefault();
    if (onClick)
      onClick(event);
  }

  const handleDownload = (fileId: { toString: () => any; }, fileName: any) => async (event: { preventDefault: () => void; }) => {
    event.preventDefault();

    if (token && fileId && fileName) {
      await downloadFile({
        documentId: fileId.toString(),
        token: token,
        documentName: fileName,
      });
    }
  };

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        if (userId) {
          const files = await getFilesByUserId(userId.toString());
          if (files) {
            setUserFiles(files);
          }
        }
      } catch (error) {
        console.error("Failed to fetch user files", error);
      }
    };

    fetchFiles();
  }, [userId]);

  const getFilteredRoles = (allRoles: SelectOption[]): SelectOption[] => {
    if (roleId === 4) {
      const allowedRoles = allRolesData.filter(role =>
        [4, 5].includes(role.value as number)
      );
      return [{ value: "0", label: "----- Select Role -----" }, ...allowedRoles];
    }
    if (roleId === 6) {
      const allowedRoles = allRolesData.filter(role =>
        [6, 7].includes(role.value as number)
      );
      return [{ value: "0", label: "----- Select Role -----" }, ...allowedRoles];
    }
    if (roleId === 2) {
      const allowedRoles = allRolesData.filter(role =>
        [2, 3, 4, 5, 6, 7].includes(role.value as number)
      );
      return [{ value: "0", label: "----- Select Role -----" }, ...allowedRoles];
    }
    if (roleId === 8) {
  const allowedRoles = allRolesData.filter(role =>
    [4, 5, 6, 7, 8].includes(role.value as number)
  );

  return [
    { value: "0", label: "----- Select Role -----" },
    ...allowedRoles
  ];
}
if (roleId === 9) {
  const allowedRoles = allRolesData.filter(role =>
    [4, 5, 9].includes(role.value as number)
  );

  return [
    { value: "0", label: "----- Select Role -----" },
    ...allowedRoles
  ];
}
if (roleId === 10) {
  const allowedRoles = allRolesData.filter(role =>
    [6, 7, 10].includes(role.value as number)
  );

  return [
    { value: "0", label: "----- Select Role -----" },
    ...allowedRoles
  ];
}

    return allRolesData;
  }

  const fileColumns = [
    {
      name: "Files",
      selector: (row: any) => (
        <div className="d-flex align-items-center">
          <span>{row.fileName}</span>
          <a
            href={row.filePath}
            download
            style={{ marginLeft: "10px", textDecoration: "none" }}
            title={`Download ${row.fileName}`}
            onClick={handleDownload(row.fileId, row.fileName)}
          >
            <FontAwesomeIcon icon={faDownload} />
          </a>
        </div>
      ),
      sortable: true,
    },
  ];
  console.log(userFiles, 'userfiless here')
  return (
    <>
      {isLoader ? (
        <div>
          <Loader />
        </div>
      ) : (
        <div>
          <AppCard title="User Information" topMargin>
            <FormProvider {...methods}>
              <form>

                <div className="row">
                  <div className="col-md-12 col-lg-6">
                    <AppLabel label="First Name" required></AppLabel>
                    <AppInput name="userFirstName" disabled={!fieldsEnabled} />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <AppLabel label="Last Name" required></AppLabel>
                    <AppInput name="userLastName" disabled={!fieldsEnabled} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-6">
                    <AppLabel label="Address"></AppLabel>
                    <AppInput name="userAddress" disabled={!fieldsEnabled} />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <AppLabel label="City"></AppLabel>
                    <AppInput name="userCity" disabled={!fieldsEnabled} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-6">
                    <AppLabel label="Zip Code"></AppLabel>
                    <AppInput name="userZipcode" disabled={!fieldsEnabled} />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <AppLabel label="Work Phone"></AppLabel>
                    <AppInput name="userPhone" disabled={!fieldsEnabled} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-6">
                    <AppLabel label="Select Role" required></AppLabel>
                    <AppSelect
                      name="userRole"
                      options={roleId !== 1 ? getFilteredRoles(allRolesData) : allRolesData}
                      disabled={!fieldsEnabled}
                      onCustomChange={handleRoleChange}
                    />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <div className="pt-5"></div>
                    <AppCheckBox name="userIsActive" label="Active" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-6">
                    <AppLabel
                      label="Routinized Testing Focus Project - Hospital"
                      required
                    ></AppLabel>
                    <AppSelect
                      name="routinizedHospital"
                      options={allRoutinizedHospitalsData}
                      disabled={!routinizedHospitalEnabled}
                      onCustomChange={handleRoutinizedHospitalChange}
                    />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <AppLabel label="Routinized Testing Focus Project - Facility"></AppLabel>
                    <AppSelect
                      name="routinizedFacility"
                      options={filteredRoutinizedFacilities}
                      disabled={!routinizedFacilityEnabled}
                    />
                  </div>
                </div>
                 <div className="row">
  <div className="col-md-12 col-lg-6">
    <AppLabel label="Created By" />
    <AppInput name="createdBy" disabled />
  </div>

  <div className="col-md-12 col-lg-6">
    <AppLabel label="Created On" />
    <AppInput name="dateCreated" disabled />
  </div>
</div>

<div className="row">
  <div className="col-md-12 col-lg-6">
    <AppLabel label="Last Updated By" />
    <AppInput name="updatedBy" disabled />
  </div>

  <div className="col-md-12 col-lg-6">
    <AppLabel label="Last Updated On" />
    <AppInput name="dateUpdated" disabled />
  </div>
</div>
                <div className="row">
                  <div className="col-md-6 col-lg-6">
                    <AppLabel label="Notes"></AppLabel>
                    <AppTextArea
                      name="userNotes"
                      rows={5}
                      disabled={!fieldsEnabled}
                    />
                  </div>
                  <div className="col-md-6 mt-2">
                    {userFiles && userFiles.length > 0 ? (
                      <AppDataTable
                        //tableHeading="User Files"
                        data={userFiles}
                        columns={fileColumns}
                        pagination={false}
                        search={false}
                      />
                    ) : (
                      <p>No files available</p>
                    )}
                  </div>
                </div>

                <div className="row my-4 justify-content-end">
                  <div className="container d-flex justify-content-end align-items-center flex-wrap flex-column flex-lg-row mt-3">
                    <div className="text-end">

                      <AppButton type="button"
                        variant="secondary"
                        onClick={handleBackButton}
                      >
                        Back</AppButton>
                      &nbsp;
                      <AppButton
                        type="submit"
                        variant="primary"
                        onClick={handleCreateUserSubmit}
                      >
                        Submit
                      </AppButton>
                      &nbsp;

                    </div>
                  </div>
                </div>
                <input type="hidden" {...methods.register("createdBy")} />
              </form>
              {/* <AppButton
                      type="button"
                      variant="secondary"
                      
                      onClick={onClick}
                    >
                      Clear
                    </AppButton>
                    &nbsp; */}

            </FormProvider>
          </AppCard>
        </div>
      )}
    </>
  );
};

export default EditUser;
